import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[nebulaIconSize]'
})
export class NebulaIconSizeDirective implements OnInit {

  constructor(private el: ElementRef) {
  }

  @Input() nebulaIconSize: string;

  ngOnInit() {
    (this.el.nativeElement as HTMLElement).style.transform = `scale(${parseInt(this.nebulaIconSize, 10) / 24})`;
  }

}
